module.exports = __webpack_public_path__ + "assets/img/33_1563_big.9b976e4b.jpg";